<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="documentationInternationalForm!">
    <h2 class="text-base font-bold text-font-primary">Additional Information</h2>
    <div class="mt-4 flex flex-col gap-4">
        <sag-ui-select
            [required]="true"
            label="Document Issue"
            placeholder="Select Document Issue"
            formControlName="documentationIssue"
            class="max-w-input"
        >
            @for (item of documentationIssues | keyvalue; track $index) {
            <sag-ui-option [value]="item.value">{{ item.value }}</sag-ui-option>
            }
        </sag-ui-select>

        @if (showDocumentationIssueOther) {
        <sag-ui-textarea
            [required]="true"
            label="Please specify the Document Issue"
            placeholder="Enter Document Issue"
            formControlName="documentationIssueOther"
            class="max-w-input"
        ></sag-ui-textarea>
        }

        <sag-ui-radio-group
            label="Did the Purchase Order contain special instructions for Documentation?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="specialInstructions" formControlName="specialInstructions" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="specialInstructions" formControlName="specialInstructions" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>

        <sag-ui-select
            [required]="true"
            label="Documentation Error Type"
            placeholder="Select Documentation Error Type"
            formControlName="documentationErrorType"
            class="max-w-input"
        >
            @for (item of documentationErrorTypes | keyvalue; track $index) {
            <sag-ui-option [value]="item.value">{{ item.value }}</sag-ui-option>
            }
        </sag-ui-select>

        @if (showDocumentationErrorTypeOther) {
        <sag-ui-textarea
            [required]="true"
            label="Please specify the Document Error"
            placeholder="Enter Document Error"
            formControlName="documentationErrorTypeOther"
            class="max-w-input"
        ></sag-ui-textarea>
        }

        <sag-ui-select
            [required]="true"
            label="Financial Adjustment Request?"
            placeholder=""
            formControlName="financialAdjustment"
            class="max-w-input"
        >
            @for (financialAdjustment of financialAdjustments() | keyvalue; track $index) {
            <sag-ui-option [value]="financialAdjustment.value">{{ financialAdjustment.value }}</sag-ui-option>
            }
        </sag-ui-select>
        <app-attachments-input [form]="documentationInternationalForm!" controlName="relatedDocuments" />
        <div class="flex justify-end max-w-input">
            <sag-ui-button [disabled]="!isValid()" (click)="handleConfirm()" size="sm">Confirm</sag-ui-button>
        </div>
    </div>
</section>
